import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { PIPELINE_QUERY_KEY } from './useGetPipeline'

type PipelineInstructionsPayload = {
  name: string
  steps: {
    instructions: string
    features: string[]
    predictionCorrections: string[]
  }[]
}

export const useEditInstructions = (programId: string, jobId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: PipelineInstructionsPayload) => {
      const { data } = await apiClient.put(
        `/int/v3/programs/${programId}/pipeline/jobs/${jobId}/instructions`,
        payload
      )
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PIPELINE_QUERY_KEY] })
    },
  })
}
